export default __webpack_public_path__ + "static/media/Img1.5c706713.jpg";